
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.184 10.066h3.25L13 4.684l-5.434 5.382h3.25v4.368h4.368v-4.368zm5.789-3.199c1.388.102 2.573.677 3.554 1.727C25.51 9.609 26 10.828 26 12.25c0 1.49-.542 2.776-1.625 3.86-1.05 1.049-2.319 1.574-3.809 1.574H6.5c-1.794 0-3.335-.627-4.621-1.88C.626 14.519 0 12.979 0 11.185 0 9.592.559 8.17 1.676 6.918c1.15-1.286 2.522-2.014 4.113-2.184a8.49 8.49 0 012.996-3.199A7.74 7.74 0 0113 .316c1.828 0 3.52.644 5.078 1.93 1.591 1.287 2.556 2.827 2.895 4.621z"}})])
          )
        }
      }
    